/**
 * Extracts roomName from Daily URL
 * @example https://meet.berrystreet.co/abc123 → abc123
 */
export const extractRoomName = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    // Remove leading and trailing slashes
    const roomName = pathname.replace(/^\/|\/$/g, '');
    return roomName || null;
  } catch {
    return null;
  }
};
